var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFileCopy48Filled = function SvgIconFileCopy48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.7 20.299-6-6c-.32-.32-.75-.5-1.2-.5h-9.4a5.31 5.31 0 0 0-5.3 5.3v15.8c0 2.92 2.38 5.3 5.3 5.3h11.8c2.92 0 5.3-2.38 5.3-5.3v-13.4c0-.45-.18-.88-.5-1.2Zm-6 2.9c-1.6 0-2.9-1.3-2.9-2.9v-3.8l6.7 6.7h-3.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 7.799H15.1a5.31 5.31 0 0 0-5.3 5.3v19.4h3.4v-19.4c0-1.05.85-1.9 1.9-1.9h15.4v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconFileCopy48Filled;